// src/components/RefundPolicy.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaUndo } from 'react-icons/fa';

const RefundPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <Link 
        to="/" 
        className="flex items-center gap-2 text-blue-600 hover:text-blue-800 mb-6"
      >
        <FaArrowLeft /> Back to Home
      </Link>

      <div className="bg-white rounded-lg shadow-md p-8">
        <div className="flex items-center gap-3 mb-6">
          <FaUndo className="text-2xl text-red-600" />
          <h1 className="text-3xl font-bold text-gray-800">Refund & Cancellation Policy</h1>
        </div>

        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Cancellation Policy</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Orders can be cancelled within 1 hour of placement</li>
              <li>Once the order is processed for delivery, cancellation may not be possible</li>
              <li>For cancellation, please contact our customer support</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Refund Policy</h2>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
              <p className="text-yellow-700">
                <strong>Note:</strong> We offer refunds only in specific cases as described below.
              </p>
            </div>
            
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Eligible for Refund:</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
              <li>Damaged or spoiled products</li>
              <li>Wrong items delivered</li>
              <li>Missing items from your order</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">Not Eligible for Refund:</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Change of mind</li>
              <li>Products that have been opened or used</li>
              <li>Perishable goods unless spoiled</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Refund Process</h2>
            <ol className="list-decimal list-inside text-gray-700 space-y-2">
              <li>Contact customer support within 24 hours of delivery</li>
              <li>Provide order details and reason for refund</li>
              <li>We may request photos of damaged products</li>
              <li>Refunds are processed within 5-7 business days</li>
              <li>Refunds will be issued to the original payment method</li>
            </ol>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;